export enum GraphsetType {
  IngestedAssetsPerMonth = "IngestedAssetsPerMonth",
  QualifiedAssetsPerDay = "QualifiedAssetsPerDay",
  ProductsMakingTime = "ProductsMakingTime",
  RestoredSizeSpeedAndDuration = "RestoredSizeSpeedAndDuration",
  DataSizeDelivered = "DataSizeDelivered",
  AssetsDeliveryPerMonth = "AssetsDeliveryPerMonth",
  SlaDeliverOrders = "SlaDeliverOrders",
}
